import { render, staticRenderFns } from "./CategoriasMenu.vue?vue&type=template&id=48f36df7&scoped=true"
import script from "./CategoriasMenu.vue?vue&type=script&lang=js"
export * from "./CategoriasMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoriasMenu.vue?vue&type=style&index=0&id=48f36df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f36df7",
  null
  
)

export default component.exports